class Newsletter {
  constructor() {
    this.settings = {
      newsletterForm: '.newsletter__form',
    };
  }

  init() {
    const newsletterForm = $(this.settings.newsletterForm);
    const $this = this;
    newsletterForm.on({
      submit(e) {
        e.preventDefault();
        $this.constructor.singUp(this);
      },
    });
  }

  static singUp($element) {
    const values = $($element).serializeArray();
    if (values) {
      let email = '';
      let name = '';
      values.forEach((el) => {
        if (el.name === 'email') {
          email = el.value;
        } else if (el.name === 'name') {
          name = el.value;
        }
      });
      const $this = $($element);
      const $message = $this.find('.message');
      $message.text('');

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        dataType: 'json',
        data: {
          email,
          name,
          action: 'sing_up_newsletter',
        },
        success(response) {
          if (response.success) {
            $this.find('input').val('');
            $message.text('Success');
          } else {
            $message.text(`${response.data}`);
          }
        },
        error(response) {
          console.log('error', response);
        },
      });
    }
  }
}

export default Newsletter;
